"use strict";
/* globals module */
/**
 * @module notificationsSettingsRoute
 * @description Baasic Notifications Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Settings Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var NotificationsSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSettingsRoute, _super);
    function NotificationsSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'notifications/settings/{id}';
        _this.updateRoute = 'notifications/settings/{id}';
        return _this;
    }
    /**
     * Parses get notification settings route; this route should be expanded with the notification provider name.
     * @method
     * @param provider The notification provider name.
     * @example notificationsSettingsRoute.get({ id: '<provider-name>' });
     */
    NotificationsSettingsRoute.prototype.get = function (provider) {
        return _super.prototype.baseGet.call(this, this.getRoute, provider);
    };
    /**
     * Parses update notification settings route; this route should be expanded with the notification provider name.
     * @method
     * @param data The notification settings.
     * @example notificationsSettingsRoute.update({ id: '<provider-name>' });
     */
    NotificationsSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    NotificationsSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsSettingsRoute);
    return NotificationsSettingsRoute;
}(common_1.BaseRoute));
exports.NotificationsSettingsRoute = NotificationsSettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
